import '.df{display:inline-flex;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.ec{padding:0 4px;}.ssr-plugin'
import '.ed{height:20px;}.ssr-plugin'
import '.ee{width:fit-content;}.ssr-plugin'
import '.ef{min-width:20px;}.ssr-plugin'
import { ReactNode } from 'react'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Text } from '../Text/index.js'
import { styled, Style } from 'inlines'

type CounterProps = {
  children: ReactNode
  color?:
    | 'neutral'
    | 'inverted'
    | 'red'
    | 'green'
    | 'purple'
    | 'orange'
    | 'white'
  style?: Style
}

export const Counter = ({
  children,
  color = 'neutral',
  style,
}: CounterProps) => {
  return (
    <styled.div className="df c b ec ed ee ef"
      style={{
        borderRadius: radius.full,
        color:
          color === 'inverted'
            ? colors.neutral100
            : color === 'white'
              ? colors.black100
              : colors.neutralInverted100,
        background:
          color === 'inverted'
            ? colors.neutralInverted100
            : colors[`${color}100`],
        ...style,
      }}
    >
      <Text selectableText={false} color="inherit" variant="subtext-medium">
        {children}
      </Text>
    </styled.div>
  )
}

export type { CounterProps }
